<template>
  <div>
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
      <h6 class="m-0 font-weight-bold text-primary">{{ title }}</h6>
    </div>

    <div class="card shadow mb-3">
      <div class="card-header py-3">
        <b-row>
          <b-col md="3" class="my-1">
            <b-form-group class="mb-0">
              <b-input-group>
                <b-form-input v-model="search" placeholder="Cari Pegawai" />
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="5" class="my-1">
            <div class="row">
              <div class="col-5">
                <v-select
                  v-model="selectedYear"
                  :options="listYears"
                  @input="onYearChange" />
              </div>
              <div class="col-7">
                <v-select
                  v-model="selectedMonth"
                  :options="listMonths"
                  @input="onMonthChange" />
              </div>
            </div>
          </b-col>

          <b-col md="4" class="my-1 text-right">
            <div class="row">
              <div class="col-5">
<!-- 
                <v-select
                  placeholder="Pilih Departemen"
                  label="Name"
                  v-model="selectedDepartment"
                  :options="listDepartments" />
 -->
              </div>

              <div class="col-7">
                <button class="btn btn-sm btn-success" @click="saveTransaction">
                  <i class="fas fa-check"></i>
                  Simpan
                </button>
                <b-dropdown text="Cetak" variant="primary" size="sm">
                  <b-dropdown-item @click="printToPDF">Cetak PDF</b-dropdown-item>
                  <b-dropdown-item>
                    <a @click="exportToExcel" download="gaji-pegawai.xls">
                      Export EXCEL
                    </a>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </b-col>

        </b-row>

      </div>

      <div class="card-body" id="printTable">
        <div class="table-responsive">
          <b-table
            head-variant="light"
            show-empty
            responsive
            no-border-collapse
            foot-clone
            small
            bordered
            striped
            sticky-header="550px"
            no-footer-sorting
            :items="tableItems"
            :fields="tableFields"
            :filter="search"
            :per-page="perPage"
            :busy="isBusy"
            :current-page="currentPage">

            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Sedang memuat...</strong>
              </div>
            </template>

            <template v-slot:head()="scope">
              <div class="text-center">{{ scope.label }}</div>
            </template>

            <template v-slot:cell()="scope">
              <div class="text-nowrap">
                {{ scope.value }}
              </div>
            </template>

            <template v-slot:cell(trueSalary)="data">
              <div class="text-nowrap">
                {{ data.value | formatRupiah }}
              </div>
            </template>

            <template v-slot:foot(name)="data">
              <div class="text-center">TOTAL ({{ totalItems }})</div>
            </template>

            <template v-slot:foot(salary)="data">
              <div class="text-nowrap">
                {{ totalSalary | formatRupiah }}
              </div>
            </template>

            <template v-slot:foot(trueSalary)="data">
              <div class="text-nowrap">
                {{ totalTrueSalary | formatRupiah }}
              </div>
            </template>

            <template v-slot:foot()="data">
              &nbsp;
            </template>

          </b-table>
        </div>

        <b-row class="mb-2">
          <b-col md="5" class="my-1">
            <b-form-group label-cols-sm="3" label="Tampilkan" class="mb-0">
              <b-form-select
                v-model="perPage"
                :options="pageOptions"
                @change="onPageSizeChange" />
            </b-form-group>
          </b-col>

          <b-col md="3" class="my-1">
          </b-col>

          <b-col md="4" class="my-1">
            <b-pagination
              align="right"
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>

      </div>
    </div>

    <img class="d-none" src="printPlaceholder.jpg">

  </div>
</template>

<script>
import printJS from 'print-js'

const LIST_MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember'
]

export default {
  props: ['title', 'type'],

  mounted() {
    this.fetchSalaryCutTypeData()

    this.fetchData()

    this.fetchDataWorkingPeriodPricing()

    this.fetchOptionData()
  },

  data() {
    return {
      tableItems: [],
      tableFields: [
        { key: 'number', label: 'No.', class: 'column-width-20', sortable: true },
        { key: 'name', label: 'Nama', class: 'column-name-width', sortable: true, stickyColumn: true, variant: 'light' },
        { key: 'firstAssignment', label: 'TMT Awal' },
        { key: 'lastAssignment', label: 'TMT Baru' },
        { key: 'workingYears', label: 'Masa THN', class: 'column-width-20', sortable: true },
        { key: 'workingMonths', label: 'Masa BLN', class: 'column-width-20' },
        { key: 'education', label: 'Pendidikan' },
        { key: 'salary', label: 'Besarnya Honor', sortable: true },
        { key: 'trueSalary', label: 'Jumlah Bersih', sortable: true },
        { key: 'account', label: 'No. Rekening' }
      ],
      totalSalary: 0,
      sumSalaryCut: [],
      totalTrueSalary: 0,
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50],
      search: '',
      isBusy: false,
      form: {
        PositionDetailID: null,
        EducationID: null,
        Price: null
      },
      listOptions: {
        positionDetails: [],
        educations: []
      },
      workingPeriodPricing: [],
      listDepartments: [],
      listSalaryCutTypes: [],
      listYears: [
        (new Date()).getFullYear() - 3,
        (new Date()).getFullYear() - 2,
        (new Date()).getFullYear() - 1,
        (new Date()).getFullYear(),
        (new Date()).getFullYear() + 1,
        (new Date()).getFullYear() + 2,
        (new Date()).getFullYear() + 3
      ],
      listMonths: LIST_MONTHS,
      selectedYear: (new Date()).getFullYear(),
      selectedMonth: LIST_MONTHS[(new Date()).getMonth()],
      selectedDepartment: ''
    }
  },

  methods: {
    fetchData () {
      this.isBusy = true

      this.$axios.get(`employee`, { params: {
        employeeType: this.type,
        search: this.search
      }}).then((res) => {
        const tableItems = []

        for (let i = 0; i < res.data.length; i++) {
          let row = res.data[i]

          let item = {}

          item.number = i + 1

          item.name = row.Name
          item.employeeId = row.ID

          if (row.EmployeeAssignments.length) {
            item.firstAssignment = this.$options.filters.formatDate(
              row.EmployeeAssignments[0].Start
            )
            item.lastAssignment = this.$options.filters.formatDate(
              row.EmployeeAssignments[row.EmployeeAssignments.length - 1].Start
            )
            item.workingYears = Math.floor(row.EmployeeAssignments[0].WorkingPeriod / 12)
            item.workingMonths = row.EmployeeAssignments[0].WorkingPeriod % 12
          } else {
            item.firstAssignment = ''
            item.lastAssignment = ''
            item.workingYears = ''
            item.workingMonths = ''
          }

          if (row.EmployeeEducations.length) {
            item.education = row.EmployeeEducations[row.EmployeeEducations.length - 1].Education.Name
          } else {
            item.education = ''
          }

          const salary = this.calculateMainSalary(row)

          item.salary = this.$options.filters.formatRupiah(
            (salary === 0) ? '' : salary
          )

          let totalSalaryCut = 0

          for (let j = 0; j < this.listSalaryCutTypes.length; j++) {

            let label = this.listSalaryCutTypes[j].Name.replace(/\s/g, '')

            if (this.listSalaryCutTypes[j].IsIndividual !== 1) {

              const cutAmount = this.listSalaryCutTypes[j].SalaryCuts[
                this.listSalaryCutTypes[j].SalaryCuts.length - 1
              ].Amount

              item[label] = this.$options.filters.formatRupiah(cutAmount)

              totalSalaryCut += cutAmount

              this.sumSalaryCut[label] += cutAmount

            } else if (row.SalaryCuts.length) {
              for (let k = 0; k < row.SalaryCuts.length; k++) {

                const cutAmount = row.SalaryCuts[k].Amount

                if (this.listSalaryCutTypes[j].ID === row.SalaryCuts[k].SalaryCutTypeID && this.listSalaryCutTypes[j].PeriodID === 1) {
                  if (this.selectedMonth === 'Januari') {
                    item[label] = this.$options.filters.formatRupiah(cutAmount)
                  } else {
                    item[label] = 0

                    this.sumSalaryCut[label] += 0
                  }
                } else if (this.listSalaryCutTypes[j].ID === row.SalaryCuts[k].SalaryCutTypeID) {

                  item[label] = this.$options.filters.formatRupiah(cutAmount)

                  totalSalaryCut += cutAmount

                  this.sumSalaryCut[label] += cutAmount
                } else {
                  item[label] = 0

                  this.sumSalaryCut[label] += 0
                }
              }
            } else {
              item[label] = 0

              this.sumSalaryCut[label] += 0
            }

          }

          item.trueSalary = salary - totalSalaryCut

          if (row.EmployeeIdentityCards.length) {
            for (let j = 0; j < row.EmployeeIdentityCards.length; j++) {
              if (row.EmployeeIdentityCards[j].IdentityCardID === 3) {
                item.account = row.EmployeeIdentityCards[j].Code
              }
            }
          } else {
            item.account = ''
          }

          this.totalSalary += salary

          this.totalTrueSalary += (salary - totalSalaryCut)

          tableItems.push(item)
        }

        this.tableItems = tableItems
        this.totalItems = tableItems.length

        this.isBusy = false
      }).catch(function (error) {
        console.log(error)
        this.isBusy = false
      })
    },

    fetchDataWorkingPeriodPricing () {
      this.$axios.get(`working-period-pricing`).then((res) => {

        this.workingPeriodPricing = res.data
      }).catch(function (error) {
        console.log(error)
      })
    },

    onPageChange (page) {
      this.currentPage = page

      this.fetchData()
    },

    onPageSizeChange (val) {
      this.perPage = val
    },

    onSearch () {
      this.fetchData()
    },

    onResetSearch () {
      this.search = ''

      this.fetchData()
    },

    onYearChange () {
      this.totalSalary = 0
      this.totalTrueSalary = 0
      this.fetchData()
    },

    onMonthChange () {
      this.totalSalary = 0
      this.totalTrueSalary = 0
      this.fetchData()
    },

    lookupWorkingPeriodPricing (workingMonths) {
      let result = 0

      for (let i = 0; i < this.workingPeriodPricing.length; i++) {
        if (workingMonths >= this.workingPeriodPricing[i].WorkingMonths) {
          result = this.workingPeriodPricing[i].Price
        }
      }

      return result
    },

    calculateMainSalary (data) {

      if (this.type === 'blud') {
        if (!data.EmployeeAssignments.length) return 0

        const positionSalaries = data.EmployeeAssignments[data.EmployeeAssignments.length - 1].PositionDetail.Position.SalaryPricings

        const employeeEducationID = data.EmployeeEducations[data.EmployeeEducations.length - 1].EducationID

        let mainSalary = 0

        if (positionSalaries) {
          let salary = 0

          for (let i = 0; i < positionSalaries.length; i++) {

            if (positionSalaries[i].EducationID === employeeEducationID) {
              salary = positionSalaries[i].Price
            }
          }

          if (salary === 0) return 0

          let workingPeriodSalary = this.lookupWorkingPeriodPricing(data.EmployeeAssignments[0].WorkingPeriod)

          mainSalary = salary + workingPeriodSalary
        }

        return mainSalary

      } else if (this.type === 'pemda') {
        if (data.SalaryPricing === null) return 0

        return data.SalaryPricing.Price
      }


    },

    generateHTML () {
      const header = `
        <h2 class="text-center">DAFTAR PENERIMA HONOR TENAGA KONTRAK KERJA</h2>
        <h2 class="text-center">RSUD Dr. SOEGIRI LAMONGAN</h2>
        <h2 class="text-center underlined">BAGIAN BULAN ${this.selectedMonth} ${this.selectedYear}</h2><br>
      `

      let tableHeader = `
        <table border="1">
          <tr>
            <th rowspan="2">NO</th>
            <th rowspan="2">Nama</th>
            <th rowspan="2">TMT TKK AWAL</th>
            <th rowspan="2">TMT TTK BARU</th>
            <th rowspan="2">MASA THN</th>
            <th rowspan="2">MASA BLN</th>
            <th rowspan="2">PENDIDIKAN</th>
            <th rowspan="2">BESARNYA HONOR</th>
            <th colspan="${this.listSalaryCutTypes.length}">POTONGAN-POTONGAN</th>
            <th rowspan="2">JUMLAH BERSIH</th>
            <th rowspan="2">No. REKENING</th>
            <th rowspan="2">TANDA TANGAN</th>
          </tr>
      `

      let salaryCutHead = '<tr>'
      for (let i = 0; i < this.listSalaryCutTypes.length; i++) {
        salaryCutHead += `<th>${this.listSalaryCutTypes[i].Name}</th>`
      }
      salaryCutHead += '</tr>'

      let content = ''

      for (let i = 0; i < this.tableItems.length; i++) {
        content += `<tr>`

        for (let prop in this.tableItems[i]) {
          if(this.tableItems[i].hasOwnProperty(prop)) {
            if (prop !== 'employeeId') {
              if (prop === 'trueSalary') {
                content += `<td>${this.$options.filters.formatRupiah(this.tableItems[i][prop])}</td>`
              } else {
                content += `<td>${this.tableItems[i][prop]}</td>`
              }
            }            
          }
        }

        if ((i + 1) % 2 !== 0) {
          content += `<td style="text-align: left">${i + 1}.</td>`
        } else {
          content += `<td style="text-align: right; padding-right: 30px;">${i + 1}.</td>`
        }

        content += `</tr>`
      }

      content += `<tr>
        <td colspan="7" style="text-align: center;"><strong>JUMLAH</strong></td>
        <td><strong>${this.$options.filters.formatRupiah(this.totalSalary)}</strong></td>

        <td colspan="${this.listSalaryCutTypes.length}">&nbsp;</td>
        <td><strong>${this.$options.filters.formatRupiah(this.totalTrueSalary)}</strong></td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>`

      const footer = `
        </table>
        <br>
        <div class="box" style="float: left;">
          <h4>MENGETAHUI / MENYETUJUI</h4>
          <h4>DIREKTUR</h4>
          <h4>RSUD Dr. SOEGIRI LAMONGAN</h4>
          <br><br><br>

          <h4>dr. MOH. CHAIDIR ANNAS, M.Mkes.</h4>
          <h4>PEMBINA TINGKAT I</h4>
          <h4>NIP. 19661113 199703 1 002</h4>
        </div>

        <div class="box" style="float: right;">
          <h4>Lamongan, &nbsp; </h4>
          <h4>BENDAHARA PENGELUARAN</h4>
          <h4>RSUD Dr. SOEGIRI LAMONGAN</h4>
          <br><br><br>

          <h4>REZHA GREYA WINDINATA, SE.</h4>
          <h4>PENATA MUDA</h4>
          <h4>NIP. 19890618 201101 1 003</h4>
        </div> 
      `

      return header + tableHeader + salaryCutHead + content + footer
    },

    printToPDF () {
      printJS({
        printable: 'printPlaceholder.jpg',
        type: 'image',
        gridHeaderStyle: 'font-weight: bold; border: 2px solid #000;',
        gridStyle: 'border: 1px solid #000;',
        header: this.generateHTML(),
        maxWidth: '1200',
        style: `
          body {
            font-family: Times, "Times New Roman", serif;
          }

          h2 {
            font-size: 1em;
            line-height: 0.5em;
            text-transform: uppercase;
          }

          h4 {
            font-size: 0.8em;
            line-height: 0em;
          }

          table {
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            font-size: 0.8em;
            padding-left: 3px;
            padding-right: 3px;
          }

          .text-center {
            text-align: center;
          }

          .underlined {
            text-decoration: underline;
          }

          .box {
            width: 300px;
            text-align: center;
          }
        `
      })
    },

    exportToExcel () {
      let excelContent = this.generateHTML()

      excelContent = excelContent.replace(/<A[^>]*>|<\/A>/g, '');//remove if u want links in your table
      excelContent = excelContent.replace(/<img[^>]*>/gi,''); // remove if u want images in your table
      excelContent = excelContent.replace(/<input[^>]*>|<\/input>/gi, ''); // reomves input params

      const ua = window.navigator.userAgent
      const msie = ua.indexOf('MSIE ');

      // If Internet Explorer
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        txtArea1.document.open('txt/html','replace')
        txtArea1.document.write(excelContent)
        txtArea1.document.close()
        txtArea1.focus() 
        
        txtArea1.document.execCommand('SaveAs', true, 'Say Thanks to Sumit.xls')
      }  
      else {
        window.open('data:application/vnd.ms-excel,' + encodeURIComponent(excelContent))  
        // const url = 'data:application/vnd.ms-excel,' + encodeURIComponent(excelContent)

        // const link = document.createElement('a')

        // link.download = "export.xls"
        // link.href = url
        // link.click()
      }
    },

    fetchOptionData () {
      this.$axios.get('/department').then((res) => {
        this.listDepartments = res.data

      }).catch(function (error) {
        console.log(error)
      })

    },

    fetchSalaryCutTypeData () {
      this.$axios.get('/salary-cut-type').then((res) => {
        this.listSalaryCutTypes = res.data

        for (let i = 0; i < res.data.length; i++) {
          this.tableFields.splice(this.tableFields.length - 2, 0, [
            { key: res.data[i].Name.replace(/\s/g, ''), label: res.data[i].Name, sortable: true },
          ])
        }

      }).catch(function (error) {
        console.log(error)
      })
    },

    saveTransaction () {
      this.isBusy = true

      let salaryCategoryID = 0

      if (this.type === 'blud') {
        salaryCategoryID = 1
      } else if (this.type === 'pemda') {
        salaryCategoryID = 4
      }


      const data = {
        transactions: []
      }

      for (let i = 0; i < this.tableItems.length; i++) {

        let transaction = {
          SalaryCategoryID: salaryCategoryID,
          EmployeeID: this.tableItems[i].employeeId,
          Year: this.selectedYear,
          Month: LIST_MONTHS.indexOf(this.selectedMonth) + 1,
          Salary: this.tableItems[i].trueSalary
        }

        data.transactions.push(transaction)
      }

      // console.log(data)


      this.$axios.post('/salary-transaction-bulk', { data }).then(res => {

        console.log(res.data)

        // this.$bvToast.toast('Data pegawai baru berhasil disimpan', {
        //   title: 'Sukses!!',
        //   variant: 'success',
        //   solid: true
        // })

      })
    }
  }
}
</script>

<style scoped>
.column-width-20 {
  width: 20px !important;
}

.column-name-width {
  width: 100px !important;
  /*font-size: 0.9em;*/
}
</style>